import PartExchangeSearch from './subviews/part-exchange-search';
import PartExchangeSaved from './subviews/part-exchange-saved';
import CurrencyFormatter from '../../../../utils/currency-formatter-lib';
import DealerMapper from "../../../../utils/dealer-mapper";

export default class PartExchange {
    constructor(parent) {
        this.parent = parent;
        this.client = parent.client;
        this.partEx = parent.partEx;
        this.pricing = parent.pricing;
        
        this.myAccount2 = window.HONDA.MyAccount2;
        this.el = parent.el.querySelector('.configurator--part-exchange');
        this.priceFormatter = new CurrencyFormatter();
        this.formatPrice = (val) => this.priceFormatter.to(val ?? 0);

        this.searchView = new PartExchangeSearch(this);
        this.savedView = new PartExchangeSaved(this);

        this.searchButton = this.el.querySelector('.part-ex-search-button');
        this.savedButton = this.el.querySelector('.part-ex-saved-button');

        this.newPartExSearch = this.el.querySelectorAll('.new-part-ex-search');
        this.loader = this.el.querySelector('.part-exchange-loader');

        this.dealerUrl = this.el?.dataset?.dealerUrl;
        this.talkToRetailerLink = this.el.querySelector('.talk-to-retailer-link');

        this.partEx.result = {};

        this.bind();
        this.init();
    }

    bind() {
        this.myAccount2?.addEventListener('login', () => this.onLogin());
        this.myAccount2?.addEventListener('close', () => this.onCancel());

        this.searchButton.addEventListener('click', (e) => this.onSearch(e));
        this.savedButton.addEventListener('click', (e) => this.onSaved(e));

        this.newPartExSearch.forEach((ele, i) => {
            ele.addEventListener('click', (e) => {
                this.onNewSearch(e);
            });
        });
    }

    onNewSearch(e) {
        e.preventDefault();
        this.reset()
        this.searchView.showSearchView();
    }

    init() {
        if (this.partEx.enabled && this.partEx.id) {            
            this.savedView.preselect();           
        }
    }

    showElements(elementList) {
        elementList.forEach((element) => {
            element.classList.remove('hide');
        });
    }

    hideElements(elementList) {
        elementList.forEach((element) => {
            element.classList.add('hide');
        });
    }

    setActive(elementList) {
        elementList.forEach((element) => {
            element.classList.add('active');
        });
    }

    removeActive(elementList) {
        elementList.forEach((element) => {
            element.classList.remove('active');
        });
    }

    async onLogin() {
        this.onNoPartEx();
        this.populatePreferredDealer();
    }

    async populatePreferredDealer() {
        const details = await window.HONDA.MyAccount2.client.getPersonalDetails();
        const dealer = details?.preferredDealercode;
        const result = dealer ? await window.HONDA.MyAccount2.client.getDealerDetails(this.dealerUrl, dealer) : null;
        const data = result ? DealerMapper.map(result) : null;
        const url = data?.alias;
        if(url){
            this.talkToRetailerLink.href = url;
        }
    }

    onCancel() {
        if (!this.myAccount2.isLoggedIn()) {
            this.partEx.enabled = false;
            this.partEx.vrm = null;
            this.partEx.data = null;

            this.removeActive([
                this.searchButton,
                this.savedButton,
            ]);
        }
    }

    onNoPartEx() {
        this.reset();
        this.removeActive([this.searchButton, this.savedButton]);

        this.searchView.hideSearchView();
        this.savedView.hideSavedView();

        this.updateValuationResult({ view: 'noPart' });
    }

    onSearch(e) {
        e.preventDefault();
        this.reset();
        this.savedView.hideSavedView();

        if (this.myAccount2?.isLoggedIn()) {
            this.searchView.showSearchView();
        } else {
            this.view = 'search';
            this.myAccount2?.showModal({ close: true, guest: false });
        }
    }

    onSaved(e) {
        e.preventDefault();

        this.reset()
        this.searchView.hideSearchView();

        if (this.myAccount2?.isLoggedIn()) {
            this.savedView.showSavedView();
        } else {
            this.view = 'saved';
            this.myAccount2?.showModal({ close: true, guest: false });
        }
    }

    updateValuationResult(option) {
        const { view } = option;
        
        if (view === 'search') {
            this.partEx.enabled = true;
            this.partEx.finance = this.partEx?.outstandingFinanceAmount;
            this.partEx.result = {
                enabled: this.partEx?.enabled,
                carId: this.partEx?.carSelected,
                equity: this.partEx?.equity,
                outstandingFinanceAmount: this.partEx?.outstandingFinanceAmount,
                registrationNumber: this.partEx?.searchedCarRegistrationNumber,
                valuationAmount: this.partEx?.searchedValuationAmount,
                valuationVehicle: this.partEx?.searchedValuationVehicle,
                selectedCarSpecs: this.partEx?.selectedCarSpecs,
                selectedCarName: [this.partEx?.selectedCarSpecs?.make, this.partEx?.selectedCarSpecs?.model, this.partEx?.selectedCarSpecs?.colour].join(' '),
                valuationResponse: this.partEx?.searchedValuationResponse,
            };
        } else if (view === 'saved') {
            this.partEx.enabled = true;
            this.partEx.finance = this.partEx?.savedOutstandingFinanceAmount;
            this.partEx.result = {
                enabled: this.partEx?.enabled,
                valuationId: this.partEx?.carSelected,
                equity: this.partEx?.savedEquity,
                outstandingFinanceAmount: this.partEx?.savedOutstandingFinanceAmount,
                registrationNumber: this.partEx?.savedCarRegistrationNumber,
                valuationAmount: this.partEx?.savedValuationAmount,
                valuationVehicle: this.partEx?.savedValuationVehicle,
                selectedCarSpecs: this.partEx?.savedCarSpecs,
                selectedCarName: [this.partEx?.savedCarSpecs?.make, this.partEx?.savedCarSpecs?.model, this.partEx?.savedCarSpecs?.colour].join(' '),
                valuationResponse: this.partEx?.currentSavedValuation,
            };
        } else {
            this.reset()
        }
    }

    reset() {
        this.partEx.reset();
    }

    showLoader() {
        this.loader.classList.remove('hide');
    }

    hideLoader() {
        this.loader.classList.add('hide');
    }
}
